const coveteur= new function(){
    const me = this;
    const config = { attributes: false, childList: true, subtree: false };
    var filter=null;
    
    me.init=()=>{
        console.log("init coveteur");
    }
    me.initReady=()=>{
        console.log("ready coveteur");
         
            
    }

    me.filtersUpdateForm=(e)=>{
        console.log("filter form");
        const allChecked =document.querySelectorAll('.filter-form input.tag__input:not([name="filter.v.availability"]):checked');
        console.log(allChecked.length===1);
        if(allChecked.length===1){
            document.querySelector('.filter-form input.tag__input[name="filter.v.availability"]').checked=true;
        }

    }
  /* ----------------- */
    me.stop=(observer)=>{observer.disconnect();};
me.addObserver=(target,callback)=>{
    console.log(`observe ${target.tagName}`);
    const observer = new MutationObserver(callback);
    observer.observe(target, config);

};
me.addObserver=(target,callback, myconfig)=>{
  	
    console.log(`observe ${target.tagName}`);
    const observer = new MutationObserver(callback);
    observer.observe(target, myconfig||config);

};
}
coveteur.init();
document.addEventListener('DOMContentLoaded', coveteur.initReady, false); 